/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Record_Session_VolumeInputs */

const en_us2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best workout volume`)
};

const pt_br2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior volume num treino`)
};

const es_419_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayor volumen en un entrenamiento`)
};

const pt_pt2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maior volume num treino`)
};

const fr_fr2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meilleur volume sur une séance`)
};

const de_de2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestes Trainingsvolumen`)
};

const it_it2_exercise_sheet_record_session_volume = /** @type {(inputs: Exercise_Sheet_Record_Session_VolumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miglior volume in un allenamento`)
};

/**
* | output |
* | --- |
* | "Best workout volume" |
*
* @param {Exercise_Sheet_Record_Session_VolumeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_record_session_volume = /** @type {((inputs?: Exercise_Sheet_Record_Session_VolumeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Record_Session_VolumeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_record_session_volume(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_record_session_volume(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_record_session_volume(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_record_session_volume(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_record_session_volume(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_record_session_volume(inputs)
	return en_us2_exercise_sheet_record_session_volume(inputs)
});
export { exercise_sheet_record_session_volume as "exercise-sheet.record_session_volume" }